module.exports = __webpack_public_path__ + "img/FileText.fd85fc32.svg";